import React from 'react'
import { useTranslation } from 'react-i18next'
import { LineChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis, Line } from 'recharts'
import { celsiusToFahrenheit, formatTime } from '../../../utils/functions'

export default function TemperatureChart(props) {
  const { data, isFahrenheit, timeFormat } = props
  const { t } = useTranslation()

  const renderTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {
      const dataPoint = payload[0].payload
      return (
        <div className="tooltip">
          <div className="tooltip-item">
            <div className="legend">
              <p>{t('advance_troubleshooting_context.temperatureChamber')}</p>
              <p className="item">{`${dataPoint.temperatureChamber.toFixed(1)}${isFahrenheit ? '°F' : '°C'}`}</p>
            </div>
            <div className="legend">
              <p>{t('time')}</p>
              <p className="item">{formatTime(timeFormat, label)}</p>
            </div>
          </div>
        </div>
      )
    }
    return null
  }

  return (
    <div className="charts-responsive-container">
      <div className="temperature-chart-wrapper">
        <ResponsiveContainer width="95%" height="90%">
          <LineChart data={data.map((d) => ({ ...d, temperatureChamber: isFahrenheit ? celsiusToFahrenheit(d.temperatureChamber) : d.temperatureChamber}))}>
            <CartesianGrid />
            <XAxis tickFormatter={(time) => formatTime(timeFormat, time)} dataKey="time" style={{ fontSize: '0.8em' }} />
            <YAxis yAxisId="left" unit={isFahrenheit ? '°F' : '°C'} style={{ fontSize: '0.8em' }} type="number" domain={['auto', 'auto']} />
            <Line
              name={isFahrenheit ? 'Temperature (°F)' : 'Temperature (°C)'}
              yAxisId="left"
              type="monotone"
              dataKey="temperatureChamber"
              stroke="#2877ba"
              strokeWidth="2"
              activeDot={{ r: 8 }}
              dot={false}
            />
            <Tooltip content={renderTooltip} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

